import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const submitAdmission = async (formData) => {
    const response = await axios.post(`${API}/admission`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

export const submitContact = async (data) => {
    const response = await api.post('/contact', data);
    return response.data;
};

export const getNews = async () => {
    const response = await api.get('/news');
    return response.data;
};

export const getEvents = async () => {
    const response = await api.get('/events');
    return response.data;
};

export const getGallery = async () => {
    const response = await api.get('/gallery');
    return response.data;
};

export const getTeachers = async () => {
    const response = await api.get('/teachers');
    return response.data;
};

export const getAdmissionCount = async () => {
    const response = await api.get('/admission-count');
    return response.data;
};

export const createCheckoutSession = async (data) => {
    const response = await api.post('/payments/v1/checkout/session', data);
    return response.data;
};

export const getCheckoutStatus = async (sessionId) => {
    const response = await api.get(`/payments/v1/checkout/status/${sessionId}`);
    return response.data;
};

export default api;